import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const CloseButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const StyledBackNavigation = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  color: 'secondaryText',
  cursor: `pointer`,
})``;
